'use client';
import { useEffect, useState } from 'react';
const getAmplitudeStorageKey = (apiKey) => {
    const suffix = apiKey.slice(-6);
    return `amp-exp-$default_instance-${suffix}`;
};
const useStoredAmplitudeVariants = (apiKey) => {
    const [variants, setVariants] = useState(null);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        try {
            const key = getAmplitudeStorageKey(apiKey);
            const storedValue = localStorage.getItem(key);
            if (storedValue) {
                setVariants(JSON.parse(storedValue));
            }
        }
        catch (error) {
            //
        }
    }, [apiKey]);
    return variants;
};
export default useStoredAmplitudeVariants;
